import bag from "../../assets/Louisanna bag.svg";
import { CardIcon, InfoIcon, MasterCardIcon } from "./PaymentInfo.styled";
import { CardDetailsProps } from "./types";
import * as Yup from "yup";
import SuccessModal from "./SuccessModal";
export const productDetails = {
  image: "/assets/Louisanna bag.png",
  title: "Louisanna Bag",
  quantity: 1,
  price: 500,
  tax: 0,
};

export const transformPrice = (price: number) => {
  return formatCurrency(price);
};

export const formatCurrency = (value: any, currency = "USD") => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  });
  return formatter.format(value);
};
export const userInformation: {
  label: string;
  type: string;
  name: string;
}[] = [
  {
    label: "Full Name",
    type: "text",
    name: "name",
  },
  {
    label: "Email Address",
    type: "email",
    name: "email",
  },
  {
    label: "Phone Number",
    type: "tel",
    name: "phone",
  },
];

export const paymentMethodsData = [
  {
    icon: (
      <img
        src="/assets/paywithcard.svg"
        alt="card icon"
        className="card_icon"
      />
    ),
    label: "Pay with Card",
    key: "pay-with-card",
    // exclude: true,
  },
  {
    icon: (
      <img
        src={"/assets/paywithaccount.svg"}
        alt="account icon"
        className="card_icon"
      />
    ),
    label: "Pay with Bank",
    key: "pay-with-bank",
  },
  {
    icon: (
      <img
        src={"/assets/command.png"}
        alt="account icon"
        className="card_icon"
      />
    ),
    label: "Others",
    key: "others",
    exclude: true,
  },
  {
    icon: (
      <img
        src={"/assets/command.png"}
        alt="account icon"
        className="card_icon"
      />
    ),
    label: "Visa",
    key: "visa",
    // exclude: true,
  },
].filter((menu) => !menu.exclude);

export const returnCardDetails = ({
  isEmpty,
}: {
  isEmpty?: boolean;
}): CardDetailsProps[] => {
  return [
    { label: "Cardholder Name", type: "text" },
    {
      label: "Cardholder Number",
      placeholder: "1234 1234 1234 1234",
      icon: isEmpty ? <CardIcon /> : <MasterCardIcon />,
      type: "number",
    },
    {
      label: "Expiry Date",
      placeholder: "MM/YY",
      type: "text",
    },
    {
      label: "CVV",
      labelIcon: <InfoIcon />,
      type: "number",
    },
  ];
};

export const payWithAccountData: CardDetailsProps[] = [
  { label: "Account holder Full Name", type: "text" },
  { label: "Bank Name", type: "text" },
  { label: "Bank Routing Number", type: "number", labelIcon: <InfoIcon /> },
  { label: "Bank Account Number", type: "number", labelIcon: <InfoIcon /> },
];

export const formatDateText = ({
  text,
}: {
  text?: string;
}): string | undefined => {
  let result = "";
  const regex = /^[0-9\/]*$/;
  if (text && regex.test(text)) {
    result += text;
    if (result.length === 2) {
      result += `/`;
    }
  }
  return result;
};

export const billingAddressData: CardDetailsProps[] = [
  { label: "Country", type: "text" },
  { label: "Address 1", type: "text" },
  { label: "Address 2", type: "text" },
  { label: "City", type: "text" },
  { label: "State", type: "" },
  { label: "Zip", type: "number" },
];

export const usaStates = [
  "Select",
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const restrictValue = ({ value }: { value: number }) => {
  const str = `${value}`;
  const arr = str.split("");
  arr.length = 3;
  return arr.join("") === "0" ? "" : arr.join("");
};

export const initialPaymentInfo = {
  cardInfo: {
    "cardholder name": "",
    "cardholder number": "",
    "expiry date": "",
    cvv: "",
  },
  billingInfo: {
    country: "",
    "address 1": "",
    "address 2": "",
    city: "",
    state: usaStates[0],
    zip: "",
  },
  shippingInfo: {
    country: "",
    "address 1": "",
    "address 2": "",
    city: "",
    state: usaStates[0],
    zip: "",
  },
};

export const StatusMessage = (
  status: "error" | "success" | "pending",
  message: string,
  reference: any
) => {
  switch (status) {
    case "error":
      return (
        <SuccessModal
          noModal
          status={"error"}
          message={`${message} not successful. Please try again`}
          reference={reference}
        />
      );
    case "success":
      return (
        <SuccessModal
          noModal
          status={"success"}
          message={`${message} successful. Thank you`}
          reference={reference}
        />
      );
    case "pending":
    default:
      return (
        <SuccessModal
          noModal
          status={"pending"}
          message={`Payment currently being processed. `}
        />
      );
  }
};
